import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-155f27bb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "productBox productBoxDesktop row h-100 no-gutters p-2 p-md-3 border rounded fade-in"
};
const _hoisted_2 = { class: "productBoxHeader col-12 font8-responsive" };
const _hoisted_3 = { class: "row no-gutters" };
const _hoisted_4 = { class: "col" };
const _hoisted_5 = {
    key: 0,
    class: "pill font8-responsive bg-brand_red fc-white [ dealPill ]"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "dealTextToExchange" }, "Neu eingetroffen", -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pill font8-responsive bg-brand_red fc-white [ dealPill ]" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "dealTextToExchange" }, "Deal")
], -1));
const _hoisted_9 = { class: "pill font8-responsive bg-brand_red fc-white [ percentPill ]" };
const _hoisted_10 = {
    key: 0,
    class: "pill font8-responsive bg-brand_green_neon fc-brand_deep_blue [ inStockPill ]"
};
const _hoisted_11 = {
    key: 1,
    class: "pill font8-responsive bg-brand_red fc-white [ numberInStockPill ]"
};
const _hoisted_12 = {
    key: 2,
    class: "pill font8-responsive bg-brand_red fc-white [ numberInStockPill ]"
};
const _hoisted_13 = {
    key: 0,
    class: "col-2 wishlist float-right"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "imageWrapper p-0 col-12 no-gutters align-items-center justify-content-center d-flex w-100" };
const _hoisted_16 = ["alt", "src"];
const _hoisted_17 = ["href"];
const _hoisted_18 = { class: "productBoxNameAndCondition row" };
const _hoisted_19 = { class: "col-12 productboxNameWrapper" };
const _hoisted_20 = { class: "productName h7-responsive" };
const _hoisted_21 = { class: "col-12 productboxCondition" };
const _hoisted_22 = { class: "productBoxPriceWrapper row no-gutters" };
const _hoisted_23 = {
    key: 0,
    class: "d-flex col p-0 mt-auto [ dealPriceWrapperDesktop ]"
};
const _hoisted_24 = { class: "productPrice h7-responsive" };
const _hoisted_25 = { class: "text-nowrap fc-red d-inline-block pr-3" };
const _hoisted_26 = {
    class: "text-nowrap font-weight-normal",
    style: { "text-decoration": "line-through" }
};
const _hoisted_27 = {
    key: 1,
    class: "d-flex col p-0 mt-auto [ normalPriceWrapperDesktop ]"
};
const _hoisted_28 = { class: "productPrice h7-responsive" };
const _hoisted_29 = { class: "text-nowrap d-inline-block" };
const _hoisted_30 = {
    key: 1,
    class: "productBox productBoxMobile row no-gutters py-3 pl-3 pr-2 border rounded overflow-hidden fade-in"
};
const _hoisted_31 = { class: "col-4 pr-2" };
const _hoisted_32 = ["href"];
const _hoisted_33 = { class: "imageWrapper" };
const _hoisted_34 = ["alt", "src"];
const _hoisted_35 = {
    class: "col-8 font8-responsive",
    style: { "display": "flex", "flex-direction": "column", "justify-content": "space-between" }
};
const _hoisted_36 = { class: "row no-gutters" };
const _hoisted_37 = { class: "col pr-2 pb-2" };
const _hoisted_38 = {
    key: 0,
    class: "pill font8-responsive bg-brand_red fc-white [ dealPill ]"
};
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "dealTextToExchange" }, "Neu eingetroffen", -1));
const _hoisted_40 = [
    _hoisted_39
];
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "pill font8-responsive bg-brand_red fc-white [ dealPill ]" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "dealTextToExchange" }, "Deal")
], -1));
const _hoisted_42 = { class: "pill font8-responsive bg-brand_red fc-white [ percentPill ]" };
const _hoisted_43 = {
    key: 0,
    class: "pill font8-responsive bg-brand_green_neon fc-brand_deep_blue [ inStockPill ]"
};
const _hoisted_44 = {
    key: 1,
    class: "pill font8-responsive bg-brand_red fc-white [ numberInStockPill ]"
};
const _hoisted_45 = {
    key: 0,
    class: "col-1 wishlist float-right"
};
const _hoisted_46 = { class: "col-12" };
const _hoisted_47 = ["href"];
const _hoisted_48 = { class: "productName h7-responsive" };
const _hoisted_49 = ["href"];
const _hoisted_50 = ["href"];
const _hoisted_51 = { class: "row no-gutters" };
const _hoisted_52 = {
    key: 0,
    class: "d-flex col p-0 mt-auto [ dealPriceWrapperMobile ]"
};
const _hoisted_53 = { class: "productPrice h7-responsive" };
const _hoisted_54 = { class: "text-nowrap fc-red d-inline-block pr-3" };
const _hoisted_55 = {
    class: "text-nowrap font-weight-normal",
    style: { "text-decoration": "line-through" }
};
const _hoisted_56 = {
    key: 1,
    class: "d-flex col p-0 mt-auto [ normalPriceWrapperMobile ]"
};
const _hoisted_57 = { class: "productPrice h7-responsive" };
const _hoisted_58 = { class: "text-nowrap d-inline-block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (_ctx.product.isNewcomer && !_ctx.product.dealPrice)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
                                : (_ctx.product.dealPrice && _ctx.product.stockAvailable)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_8,
                                        _createElementVNode("span", _hoisted_9, " - " + _toDisplayString(_ctx.product.percent) + " % ", 1)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (_ctx.product.stockAvailable > 7)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Auf Lager "))
                                            : _createCommentVNode("", true),
                                        (_ctx.product.stockAvailable <= 7 && _ctx.product.stockAvailable > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Nur noch " + _toDisplayString(_ctx.product.stockAvailable) + " Stk. ", 1))
                                            : _createCommentVNode("", true),
                                        (!_ctx.product.stockAvailable)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Ausverkauft "))
                                            : _createCommentVNode("", true)
                                    ], 64))
                        ]),
                        (!_ctx.isModelBoxView)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("i", {
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.wishListAction(_ctx.product.id))),
                                    class: _normalizeClass(["float-right float h4 pointerhover wishListButton", {
                                            'icon-heart fc-red': _ctx.isOnWishlist(_ctx.product.id),
                                            'icon-herz': !_ctx.isOnWishlist(_ctx.product.id),
                                        }]),
                                    style: { "margin-top": "-2px" }
                                }, null, 2)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("a", {
                    href: _ctx.product.link,
                    class: "productBoxMain col-12 pointerhover",
                    title: "Zum Produkt"
                }, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                            alt: _ctx.product.name,
                            src: _ctx.optimizeImage(_ctx.product.mainImage)
                        }, null, 8, _hoisted_16)
                    ])
                ], 8, _hoisted_14),
                _createElementVNode("a", {
                    href: _ctx.product.link,
                    class: "productBoxFooter col-12 pointerhover p-0 align-self-end",
                    title: "Zum Produkt"
                }, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.product.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("small", null, _toDisplayString(_ctx.product.condition), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        (_ctx.product.dealPrice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("span", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.isModelBoxView ? 'ab' : 'nur') + " " + _toDisplayString(_ctx.dealPriceCommaSeparated), 1),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.originalPriceCommaSeperated), 1)
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("span", _hoisted_28, [
                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.isModelBoxView ? 'ab' : 'nur') + " " + _toDisplayString(_ctx.originalPriceCommaSeperated), 1)
                                ])
                            ]))
                    ])
                ], 8, _hoisted_17)
            ]))
            : _createCommentVNode("", true),
        (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("a", {
                        href: _ctx.product.link,
                        class: "pointerhover",
                        title: "Zum Produkt"
                    }, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("img", {
                                alt: _ctx.product.name,
                                src: _ctx.optimizeImage(_ctx.product.mainImage)
                            }, null, 8, _hoisted_34)
                        ])
                    ], 8, _hoisted_32)
                ]),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                            (_ctx.product.isNewcomer && !_ctx.product.dealPrice)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _hoisted_40))
                                : (_ctx.product.dealPrice && _ctx.product.stockAvailable)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_41,
                                        _createElementVNode("span", _hoisted_42, " - " + _toDisplayString(_ctx.product.percent) + " % ", 1)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (_ctx.product.stockAvailable > 7)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Auf Lager "))
                                            : _createCommentVNode("", true),
                                        (_ctx.product.stockAvailable <= 7)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, " Nur noch " + _toDisplayString(_ctx.product.stockAvailable) + " Stk. ", 1))
                                            : _createCommentVNode("", true)
                                    ], 64))
                        ]),
                        (!_ctx.isModelBoxView)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("i", {
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.wishListAction(_ctx.product.id))),
                                    class: _normalizeClass(["float-right float h6 wishListButton pointerhover", {
                                            'icon-heart fc-red': _ctx.isOnWishlist(_ctx.product.id),
                                            'icon-herz': !_ctx.isOnWishlist(_ctx.product.id),
                                        }]),
                                    style: { "margin-top": "-2px" }
                                }, null, 2)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("a", {
                                href: _ctx.product.link,
                                title: "Zum Produkt"
                            }, [
                                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.product.name), 1)
                            ], 8, _hoisted_47)
                        ]),
                        _createElementVNode("a", {
                            href: _ctx.product.link,
                            title: "Zum Produkt",
                            class: "col-12 font8-responsive h-100"
                        }, _toDisplayString(_ctx.product.condition), 9, _hoisted_49)
                    ]),
                    _createElementVNode("a", {
                        href: _ctx.product.link,
                        title: "Zum Produkt"
                    }, [
                        _createElementVNode("div", _hoisted_51, [
                            (_ctx.product.dealPrice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createElementVNode("span", _hoisted_53, [
                                        _createElementVNode("span", _hoisted_54, "nur " + _toDisplayString(_ctx.product.dealPrice) + " €", 1),
                                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.product.originalPrice) + " € ", 1)
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _createElementVNode("span", _hoisted_57, [
                                        _createElementVNode("span", _hoisted_58, "nur " + _toDisplayString(_ctx.product.originalPrice) + " €", 1)
                                    ])
                                ]))
                        ])
                    ], 8, _hoisted_50)
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
